import styled, { css } from 'styled-components';

// Constellation Components
import {
    spaceMixin,
    mediaMixin,
} from '@zillow/constellation';

import {
    Col,
    Link,
} from '@zillow/zrs-comet';

export const StyledControlsDiv = styled.div`
    padding-top: ${spaceMixin('sm')};
    text-align: right;
`;

export const StyledEvenCol = styled(Col)(({
    even,
}) => css`
    ${even && css`
        padding-bottom: ${spaceMixin('xs')};
        ${mediaMixin('lg', css`
            padding-bottom: ${spaceMixin(0)};
        `)};
    `}
`);

export const StyledLink = styled(Link)`
    margin-right: ${spaceMixin('sm')};
`;
